import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';
import { FormService } from '../../form/form.service';
import { HiddenQuestion } from '../../form/models/question-hidden.model';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
@Component({
    selector: 'configure-uiengine',
    templateUrl: './configure-uiengine.component.html',
    styleUrls: ['./configure-uiengine.component.scss'],
    providers: [FormService],
    standalone: false
})
export class ConfigureUiEngineComponent implements OnInit {
  public config: any = {};
  public map: any = {}
  // public summary: any = {};
  public noInvertedAr = ["searchs", "orders", 
    "tab_orders", "def_filters","def_complex_value",
    "def_add_prefix", "cap_orders", "menu_orders", "add_btn", 
    "confirm_actions","menus","sort_allowed","dwn_all_interval",
    "config_def","summary_sequence","fields_currency_config","summary_currency_config","comma_seprated_fields" ];
  constructor(
    public smartModalService: SmartModalService,
    public injector: Injector,
    public route: ActivatedRoute,
    public dialogRef: DialogRef,
    public baseService: BaseService,
    public alertSevice: AlertsService,
    public loaderService: LoaderService,
    public dialogConfig: DialogConfig,
    public formService: FormService,
    public preferenceService: PreferenceService,
    public appService: AppService,
    public storge: StorageService
  ) {
    this.map = preferenceService.getConfigFields();
  }

  ngOnInit() {
    this.config.languageMap = {};
    var datasourceGroup = {
      "application": "account-management",
      "resource": "user_group",
      "query_id": "GET_ALL"
    }
    // this.communicationService.emitSummaryAllData$.subscribe((data) => {
    //   if(data){
    //     this.summary = this.preferenceService.getSummaryFields(data);
    //   }
    // })

    this.config.data = {};
    if (this.dialogConfig["data"] != undefined) {
      this.config.data = this.dialogConfig["data"];
    }

    var userGroupList: any = [];
    this.loaderService.showSpinner();
    if (this.dialogConfig["key"] != undefined) {
      let key = this.dialogConfig["key"].replace("account__", "");
      this.preferenceService.getUserPreferenceConfig(key, (currentConfigData) => {
        console.log("currentConfigData==>", currentConfigData)
        if (currentConfigData[this.dialogConfig["key"]] != undefined) {
          this.config.data = currentConfigData[this.dialogConfig["key"]];
        } else {
          this.config.data = {};
        }
        this.baseService.getByDataSource(datasourceGroup).subscribe(
          (data: any) => {
            //if not print
            if (data.errCode == -1) {
              this.initForm({ userGroupList: userGroupList });
            } else {
              if (data.resource != undefined && data.resource.length > 0) {
                userGroupList.push({ id: "all", value: "All" });
                for (let index = 0; index < data.resource.length; index++) {
                  var groups = data.resource[index];
                  userGroupList.push({ id: groups.user_group_name, value: groups.user_group_name });
                }
              }
              this.initForm({ userGroupList: userGroupList });
            }
            this.loaderService.hideSpinner();

          }, error => {
            this.loaderService.hideSpinner();
            this.initForm({ userGroupList: userGroupList });
          }
        );
      }, true);
    }

  }

  parseInput(key, allList) {
    var inputKey = this.map[key];
    if ((this.config.data != undefined && this.config.data[key] != undefined && allList.length > 0) ||   ["menus"].indexOf(key)>-1) {
      this.config.defaultFormData[key] = [];
      for (let user_group_name in this.config.data[key]) {
        if (Array.isArray(this.config.data[key][user_group_name]) && this.config.data[key][user_group_name].length > 0) {
          var fieldList = [];
          if(allList.length>0){
            for (let index = 0; index < allList.length; index++) {
              let field = allList[index];
              if (this.noInvertedAr.indexOf(key) > -1) {
                switch (key) {
                  case "orders":
                  case "tab_orders":
                  case "cap_orders":
                  case "summary_sequence":  
                    var col = this.config.data[key][user_group_name].find(({ id }) => id == field.id);
                    if (col) {
                      let newField = { ...field };
                      newField.order = col.o;
                      fieldList.push(newField);
                    }
                    break;
                  case "menu_orders":
                    var col = this.config.data[key][user_group_name].find(({ id }) => id == field.id);
                    let newField = { ...field };
                    //override the changed one and keep the default as it is
                    if (col) {
                      newField.order = col.o;
                      newField.changed = true;
                    }
                    fieldList.push(newField);
                    break;
                  case "menus":
                    var col = this.config.data[key][user_group_name].find(({ id }) => id == field.id);
                    let newFieldM = { ...field };
                    fieldList.push(newFieldM);
                    break;
                  case "def_filters":
                  case "def_complex_value":
                  case "def_add_prefix": 
                    var col = this.config.data[key][user_group_name].find(({ id }) => id == field.id);
                    var defField = { ...field };
                    if (col) {
                      defField.selectedVal = col.v;
                      fieldList.push(defField);
                    } else {
                      fieldList.push(defField)
                    }
                    break;
                  case "fields_currency_config":  
                  case "summary_currency_config":
                  case "comma_seprated_fields":  
                    var col = this.config.data[key][user_group_name].find(({ id }) => id == field.id);
                    var defField = { ...field };
                    if (col) {
                      defField.selectedVal = col.v;
                      fieldList.push(defField);
                    } else {
                      defField.selectedVal = false;
                      fieldList.push(defField)
                    }
                    break;   
                  default:
                    if (this.config.data[key][user_group_name].indexOf(field.id) > -1) {
                      fieldList.push(field);
                    }
                    break;
                }

              } else {
                switch (key) {
                case "menu_orders":
                default:
                    if (this.config.data[key][user_group_name].indexOf(field.id) == -1) {
                      fieldList.push(field);
                    }
                }
              }
            }
          }else{
            if (this.noInvertedAr.indexOf(key) > -1) {
              switch (key) {
                case "menus":
                    let newFieldM = { ...this.config.data[key][user_group_name] };
                    fieldList = Object.values(newFieldM);                
                    break;
              }
            }else{
              //nothing to do yet
            }
          }
            
          this.config.defaultFormData[key].push({ user_group_name: user_group_name, [inputKey]: fieldList });
        } else {
          this.config.defaultFormData[key].push({ user_group_name: user_group_name, [inputKey]: allList });
        }
      }
    }
  }



  async initForm(config) {

    this.getAllColumns(this.dialogConfig["resourceDef"]).then((allFields: any) => {
      this.getAllActions(this.dialogConfig["resourceDef"]).then((allActions: any) => {
        this.getAllTabs(this.dialogConfig["resourceDef"]).then((allTabs: any) => {
          this.getAllFilters(this.dialogConfig["resourceDef"]).then((allFilters: any) => {
            this.getAllSearchs(this.dialogConfig["resourceDef"]).then((allSearchs: any) => {
              this.getAllActions(this.dialogConfig["resourceDef"], true).then((allCapOrders: any) => {
                //this.getAllMenus(this.dialogConfig["resourceDef"], true).then((allMenus: any) => {
                this.getAllAddSearchs(this.dialogConfig["resourceDef"]).then((allAddBtns: any) => {
                  this.getAllHeaders(this.dialogConfig["resourceDef"]).then((allHeaders: any) => {
                    this.getAllCareType().then((allCareTypes: any) => {
                      this.getEditableGridCaps(this.dialogConfig["resourceDef"]).then((allEgCaps: any) => {
                        this.getBannerActions(this.dialogConfig).then((allBannerActions: any) => {
                          this.getAllowedSorting(this.dialogConfig["resourceDef"]).then((sortAllowed: any) => {
                            this.getAllConfirmActions(this.dialogConfig["resourceDef"]).then((allconfirmActions: any) => {
                              this.getDownloadAllInterval(this.dialogConfig["resourceDef"]).then((dwnAllInterval: any) => {
                                this.getSummaryFields().then((summaryDef: any) => {
                                  this.getGridConfig(this.dialogConfig["resourceDef"]).then(async (configDef: any) => {
                                    this.config["allFields"] = config["allFields"] = allFields;
                                    this.config["allActions"] = config["allActions"] = allActions;
                                    this.config["allTabs"] = config["allTabs"] = allTabs;
                                    this.config["allFilters"] = config["allFilters"] = allFilters;
                                    this.config["allSearchs"] = config["allSearchs"] = allSearchs;
                                    this.config["allOrders"] = config["allOrders"] = allFields;
                                    this.config["allCommaSeprated"] = config["allCommaSeprated"] = (this.dialogConfig?.["context"] == 'banner') ? await this.getBannerFields(this.dialogConfig?.["jsonFields"]) : allFields;
                                    this.config["fieldCurrencyConfig"] = config["fieldCurrencyConfig"] = allFields;
                                    this.config["allTabOrders"] = config["allTabOrders"] = allTabs;
                                    this.config["allDefaultFilters"] = config["allDefaultFilters"] = this.supportedDefaults(allFilters);
                                    this.config["defComplexSearchValue"] = config["defComplexSearchValue"] = JSON.parse(JSON.stringify(allSearchs))
                                    this.config["defAddPrefix"] = config["defAddPrefix"] = JSON.parse(JSON.stringify(allAddBtns))
                                    this.config["allCapOrders"] = config["allCapOrders"] = allCapOrders;
                                    this.config["allMenus"] = config["allMenus"] = [];
                                    this.config["allMenuOrders"] = config["allMenuOrders"] = [];
                                    this.config["allAddBtns"] = config["allAddBtns"] = allAddBtns;
                                    this.config["allHeaders"] = config["allHeaders"] = allHeaders;
                                    this.config["allCareTypes"] = config["allCareTypes"] = allCareTypes;
                                    this.config["allEgCaps"] = config["allEgCaps"] = allEgCaps;
                                    this.config["allBannerActions"] = config["allBannerActions"] = allBannerActions;
                                    this.config['confirm_actions'] = config["confirm_actions"] = allconfirmActions;
                                    this.config['sortAllowed'] = config["sortAllowed"] = sortAllowed;
                                    this.config['dwnAllInterval'] = config["dwnAllInterval"] = dwnAllInterval;
                                    this.config['summaryDef'] = config["summaryDef"] = summaryDef;
                                    this.config['summarySequence'] = config["summarySequence"] = summaryDef;
                                    this.config["summaryCurrencyConfig"] = config["summaryCurrencyConfig"] = summaryDef;
                                    this.config['configDef'] = config["configDef"] = configDef;
                                    /************************************INPUT DATA PARSING **********/
                                    this.config.defaultFormData = {};
                                    for (let m in this.map) {
                                      this.parseInput(m, this.config[this.map[m]]);
                                    }
                                    /************************************INPUT DATA PARSING **********/
                                    console.log("config===>", this.config);

                                    this.saveConfigureUiengineFieldsJson(config);
                                    this.saveConfigureUiengineConfigJson(config);
                                    this.saveConfigureUiengineSubJson(config, "actions", "act");
                                    this.saveConfigureUiengineSubJson(config, "tabs", "tab");
                                    this.saveConfigureUiengineSubJson(config, "menus", "menu");
                                    this.saveConfigureUiengineSubJson(config, "filters", "filter");
                                    this.saveConfigureUiengineSearchJson(config, "searchs", "field");
                                    this.saveConfigureUiengineSearchJson(config, "dwn_all_interval", "field");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "number", component: "numberbox", valKey: "order", valLabel: "field.label.order" }, ...config }, "orders", "field.label.cols");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "number", component: "numberbox", valKey: "order", valLabel: "field.label.order" }, ...config }, "tab_orders", "tab");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "string", component: "textbox", valKey: "selectedVal", valLabel: "field.label.value", valRequired: false }, ...config }, "def_filters", "filter");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "string", component: "textbox", valKey: "selectedVal", valLabel: "field.label.value", valRequired: false }, ...config }, "def_complex_value", "filter");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "string", component: "textbox", valKey: "selectedVal", valLabel: "field.label.value", valRequired: false }, ...config }, "def_add_prefix", "filter");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "number", component: "numberbox", valKey: "order", valLabel: "field.label.order" }, ...config }, "cap_orders", "act");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "boolean", component: "checkbox", valKey: "selectedVal", valLabel: "field.label.comma_disable", valRequired: false}, ...config }, "comma_seprated_fields", "act");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "boolean", component: "checkbox", valKey: "selectedVal", valLabel: "field.label.currency_type", valRequired: false}, ...config }, "fields_currency_config", "act");
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "boolean", component: "checkbox", valKey: "selectedVal", valLabel: "field.label.currency_type", valRequired: false}, ...config }, "summary_currency_config", "act");
                                    //this.saveConfigureUiengineOrderJson({ ...{ type: "number", component: "checkbox", valKey: "visible", valLabel: "field.label.order", valRequired: false }, ...config }, "menus", "hmenu");
                                    this.saveConfigureUiengineSubJson(config, "menus", "hmenu");
                                    //this.saveConfigureUiengineOrderJson({ ...{ type: "number", component: "numberbox", valKey: "order", valLabel: "field.label.order" }, ...config }, "menu_orders", "omenu");
                                    this.saveConfigureUiengineSearchJson(config, "add_btn", "field");
                                    this.saveConfigureUiengineSubJson(config, "headers", "cheadc");
                                    this.saveConfigureUiengineSubJson(config, "careTypes", "care_type");
                                    this.saveConfigureUiengineSummaryJson(config);
                                    this.saveConfigureUiengineOrderJson({ ...{ type: "number", component: "numberbox", valKey: "order", valLabel: "field.label.order" }, ...config }, "summary_sequence", "field.label.cols");
                                    this.saveConfigureUiengineSubJson(config, "eg_caps", "act");
                                    this.saveConfigureUiengineSubJson(config, "banner_actions", "act");
                                    this.saveConfigureUiengineSubJson(config, "confirm_actions", "Confirm Actions");
                                    this.saveConfigureUiengineSearchJson(config, "sort_allowed", "Default Sorting");

                                    this.config.resourceDef = this.getInitalFormJson(this.dialogConfig);
                                    this.config.currentFields = {};
                                    this.baseService.getReferredField(this.config.resourceDef.form, (response) => {
                                      this.config.fromConfig = {
                                        "submitButton": true,
                                        "cancelButton": false,
                                        "delegateSave": true,
                                      }
                                      this.config.currentFields['blocks'] = response;
                                    });
                                  });
                                });
                                });
                              })
                            });
                          });
                        });
                      });
                    });
                  });
                  //});
                });
              });
            });
          });
        });
      });

    }


  ngOnDestroy() {

  }
  supportedDefaults(allFilters) {
    if (allFilters != undefined && Array.isArray(allFilters) && allFilters.length > 0) {
      var supportedInputs = this.preferenceService.getSupportedInptus();
      var newAr = [];
      for (let index = 0; index < allFilters.length; index++) {
        let filter = allFilters[index];
        if (filter["controlType"] != undefined && supportedInputs.indexOf(filter["controlType"]) > -1) {
          switch (filter["controlType"]) {
            case supportedInputs[0]:
              if (filter["selected"] != undefined && filter["selected"]) {
                filter["selectedVal"] = PreferenceService.TODAY;
              } else {
                filter["selectedVal"] = '';
              }
              newAr.push(filter);
              break;
            case supportedInputs[1]:
              if (filter["defaultsetting"] != undefined && filter["defaultsetting"]["singleSelection"] != undefined && filter["defaultsetting"]["singleSelection"]) {
                newAr.push(filter);//only  single selection is allowed to configure
              }

              break;
            default:
              newAr.push(filter);
              break;
          }
        }
      }
      return newAr;
    }
    return [];
  }

  parseOutput(key, dataAr) {

    var finalData: any = false;
    if (dataAr != undefined && Array.isArray(dataAr) && dataAr.length > 0) {
      finalData = {};
      for (let index = 0; index < dataAr.length; index++) {
        let field = dataAr[index];
        if (field[this.map[key]] != undefined && field[this.map[key]].length > 0) {
          var mapAr = [];
          finalData[field["user_group_name"]] = [];

          for (let i = 0; i < field[this.map[key]].length; i++) {
            let col = field[this.map[key]][i];
            switch (key) {
              case "orders":
              case "tab_orders":
              case "cap_orders":
              case "summary_sequence":    
                if (col.order != undefined && col.id != undefined) {
                  mapAr.push({ id: col.id, o: col.order });
                }
                break;
              case "menu_orders":
                var allMenus = this.config[this.map[key]];
                if (col.order != undefined && col.id != undefined && allMenus && allMenus.length > 0) {
                  let origMenu = allMenus.find(({ id }) => id == col.id);
                  if (origMenu && origMenu.order != undefined && col.order != origMenu.order) {
                    mapAr.push({ id: col.id, o: col.order });
                  }
                }
                break;
              case "def_filters":
              case "def_complex_value":
              case "def_add_prefix":
              case "fields_currency_config":
              case "summary_currency_config":
              case "comma_seprated_fields":  
                if (col.selectedVal != undefined && col.id != undefined && col.selectedVal != "") {
                  mapAr.push({ id: col.id, v: col.selectedVal });
                }
                break;
              case "menus":
                if (col.id != undefined) {
                  mapAr.push({id:col.id,text:col.text});
                }
                break;
              default:
                mapAr.push(col.id);
                break;
            }

          }

          if (this.noInvertedAr.indexOf(key) == -1) {
            for (let i = 0; i < this.config[this.map[key]].length; i++) {
              let col = this.config[this.map[key]][i];
              if (mapAr.indexOf(col.id) == -1) {
                finalData[field["user_group_name"]].push(col.id);
              }
            }
          } else {
            finalData[field["user_group_name"]] = mapAr;
          }
        } 
      }
    }
    return finalData;
  }
  onSaveFinished(event) {
    if (event.result != undefined) {

      var finalData = {};

      for (let m in this.map) {
        var fields = this.parseOutput(m, event.result[m]);
        if (fields) {
          finalData[m] = fields;
        }
      }
      if (this.config.data.filter__ != undefined) {
        finalData["filter__"] = this.config.data.filter__;
      }
      console.log("finalData===>", finalData);
      this.smartModalService.sendResult(finalData);
      this.dialogRef.close(finalData);
    } else {
      this.alertSevice.error("Configuration Error");
    }

  }

  async getSummaryFields() {
    if (this.storge.getSessionStorageDataSync("summary_config")) {
      let summaryFields = this.preferenceService.getSummaryFields(this.storge.getSessionStorageDataSync("summary_config"));
      return await this.parseFields(summaryFields);
    } else {
      return [];
    }
  }

  async getGridConfig(resourceDef) {
    if(resourceDef.config == undefined){
      resourceDef.config = {};
    }
    if(resourceDef && resourceDef.config){
      try{
        return await this.parseFields(this.getConfigurationNumberJson().map((item) => {return {...item,id:item.name,text:item.heading}}));
      }catch(e){
        console.error("Error in getting grid config", e);
        return
      }
    }else{
      return [];
    }
  }

  saveConfigureUiengineFieldsJson(config) {
    var json: any = this.getConfigureUiengineJson("configure_uiengine_fields", config);
    this.baseService.saveJsonDef(json.resource, json);
  }
  saveConfigureUiengineSummaryJson(config) {
    var json: any = this.getConfigureUiengineJson("configure_uiengine_summary", config,true,"summary_def");
    this.baseService.saveJsonDef(json.resource, json);
  }

  saveConfigureUiengineConfigJson(config){
    var json: any = this.getConfigureUiengineJson("configure_uiengine_config", config,true,"config_def");
    this.baseService.saveJsonDef(json.resource, json);
  }

  saveConfigureUiengineSubJson(config, key, label) {
    var json: any = this.getConfigureUiengineSubJson(config, key, label);
    if (label == "hmenu") {
      json.form.blocks[0].fields[1] = {
          "label": "hmenu",
          "required": true,
          "getterKey": "user_friendly_name",
          "getterValue": "menu_item_name",
          "populate_field": true,
          "format": "(item) => `${item.menu_item_name} || ${item.user_friendly_name}`",
          "order": 4,
          "type": "Array",
          "component": "searchselect",
          "req_keys": [
              "user_friendly_name",
              "url",
              "appLink",
              "description",
              "menu_item_name",
              "menu_item_code"
          ],
          "defaultsetting": {
              "singleSelection": false,
              "closeDropDownOnSelection": true,
              "allowSearchFilter": true,
              "checkBoxRequired": false,
              "apliCall": true,
              "advancesearch":false
          },
          "datasource": {
              "application": "account-management",
              "search_columns": "menu_item_name",
              "resource": "menu_item_master",
              "query_id": "GET_ALL",
              "key": "id"
          },
          "name": "allMenus"
      }
      json["list"]["fields"][1]["format"] = "(item) => {return (item.text != undefined)?`${item.text}`:''}";
    }
    this.baseService.saveJsonDef(json.resource, json);
  }

  saveConfigureUiengineOrderJson(config, key, label) {
    config["key"] = key;
    var json: any = this.getConfigureUiengineSubJson(config, key, label);
    this.saveConfigureUiengineEditGridJson(config);
    json.form.blocks[0].fields[1] = {
      "order": 2,
      "type": "editgrid",
      "component": "editgrid",
      "name": this.map[key],
      "resource": "name_order_" + config["key"],
      "data": config[this.map[key]]
    }
    json["form"]["blocks"][0]["fields"][1]["label"] = label;
    json["list"]["fields"][1]["name"] = this.map[key];
    json["list"]["fields"][1]["heading"] = label;
    if (label == "hmenu") {
      json["list"]["fields"][1]["format"] = "(item) => {return (!item." + config.valKey + ")?`${item.text}`:''}";//not used anymore
    } else if (label == "omenu") {
      json["list"]["fields"][1]["format"] = "(item) => {return (item.changed != undefined)?`${item.text}-${item." + config.valKey + "}`:'' }";
    } else if (label == "filter") {
      json["list"]["fields"][1]["format"] = "(item) => {return (item." + config.valKey + " != undefined && item." + config.valKey + " != '')?`${item.text}:${item." + config.valKey + "}`:'' }";
    } else {
      json["list"]["fields"][1]["format"] = "(item) => `${item.text}:${item." + config.valKey + "}`";
    }

    delete json.form.blocks[0]["array_type"];
    this.baseService.saveJsonDef(json.resource, json);
  }

  getConfigureUiengineSubJson(config, key, label) {
    var json: any = this.getConfigureUiengineJson("configure_uiengine_" + key, config);
    json["form"]["blocks"][0]["fields"][1]["datasource"]["possible_value"] = config[this.map[key]];
    json["form"]["blocks"][0]["fields"][1]["name"] = this.map[key];
    json["form"]["blocks"][0]["fields"][1]["label"] = label;
    json["list"]["fields"][1]["name"] = this.map[key];
    json["list"]["fields"][1]["heading"] = label;
    return json;
  }

  saveConfigureUiengineSearchJson(config, key, label) {
    var json: any = this.getConfigureUiengineSubJson(config, key, label);
    json["form"]["blocks"][0]["fields"][1]["defaultsetting"]["limitSelection"] = 1;
    json["form"]["blocks"][0]["fields"][1]["defaultsetting"]["enableCheckAll"] = false;
    json["form"]["blocks"][0]["fields"][1]["defaultsetting"]["checkBoxRequired"] = false;
    this.baseService.saveJsonDef(json.resource, json);
  }

  saveConfigureUiengineEditGridJson(config) {
    var json: any = {
      "resource": "name_order_" + config["key"],
      "schema_name": "edit_grid",
      "layout_type": "edit_grid",
      "settings": {
        "add_new": false,
        "last_row_add": true,
        "sum": false,
        "table": true,
        "tile": false,
        "selectall": false,
        "index": false,
        "print": false,

        "search": false,
        "default_row": false
      },
      "list": {
        "fields": [
          {
            "name": "id",
            "component": "hidden",
            "type": "string"
          },
          {
            "label": "Name",
            "order": 1,
            "name": "text",
            "component": "label",
            "type": "string"
          },
          {
            "label": config.valLabel,
            "name": config.valKey,
            "component": config.component,
            "order": 2,
            "type": config.type,
            "required": (config.valRequired != undefined) ? config.valRequired : true
          }
        ]
      }
    };
    this.baseService.saveJsonDef(json.resource, json);
  }

  getConfigureUiengineJson(resource, config,summary = false,key="summary_def") {
    var json: any = this.getBasicJson();
    json.resource = resource;
    json.form["blocks"] = [
      {
        "name": "actions",
        "order": 1,
        "array_type": "flat",
        "fields": [
          {
            "label": "pul",
            "order": 1,
            "type": "String",
            "required": true,
            "component": "dropdown",
            "datasource": {
              possible_value: config.userGroupList
            },
            "name": "user_group_name"
          },
          {
            "label": "field.label.cols",
            "order": 2,
            "type": "Array",
            "getterKey": "id",
            "getterValue": "text",
            "required": true,
            "defaultsetting": {
              "singleSelection": false,
              "allowSearchFilter": true,
              "checkBoxRequired": true,
              "apliCall": false,
              "itemsShowLimit": 5,
              "advancesearch": false,
              "enableCheckAll": true
            },
            "component": "searchselect",
            "datasource": {
              possible_value: this.config[summary?this.map[key]:this.map["fields"]]
            },
            "name": summary?this.map[key]:this.map["fields"]
          }
        ],
        "titile": ""
      }
    ];
    json.list = {
      "fields": [
        {
          "heading": "pul",
          "card_tag": null,
          "order": 1,
          "sortable": false,
          "name": "user_group_name"
        },
        {
          "heading": "field.label.cols",
          "card_tag": null,
          "type": "array",
          "format": "(item) => `${item.text}`",
          "order": 2,
          "sortable": false,
          "name": summary?this.map[key]:this.map["fields"]
        },
      ]
    }
    json.config = {
      "add_required": false,
      "table": true,
      "tile": false,
      "formType": "aside",
      "composite_form": true,
      "account_aware": {
        "auto_filters": false,
        "auto_columns": false,
        "post": false
      }
    };
    return json;

  }

  // getConfigureUiengineCommaJson(resource, config) {
  //   var json: any = this.getBasicJson();
  //   json.resource = resource;
  //   json.form["blocks"] = [
  //     {
  //       "name": "actions",
  //       "order": 1,
  //       "array_type": "flat",
  //       "fields": [
  //         {
  //           "label": "pul",
  //           "order": 1,
  //           "type": "String",
  //           "required": true,
  //           "component": "dropdown",
  //           "datasource": {
  //             possible_value: config.userGroupList
  //           },
  //           "name": "user_group_name"
  //         }
  //       ],
  //       "titile": ""
  //     }
  //   ];
  //   json.list = {
  //     "fields": [
  //       {
  //         "heading": "pul",
  //         "card_tag": null,
  //         "order": 1,
  //         "sortable": false,
  //         "name": "user_group_name"
  //       },
  //       {
  //         "heading": "field.label.disable_comma",
  //         "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
  //         "order": 2,
  //         "card_tag": null,
  //         "sortable": true,
  //         "name": "comma_config"
  //       },
  //       {
  //         "heading": "field.label.currency",
  //         "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
  //         "order": 3,
  //         "card_tag": null,
  //         "sortable": true,
  //         "name": "currency_config"
  //       },
  //     ]
  //   }
  //   json.config = {
  //     "add_required": false,
  //     "table": true,
  //     "tile": false,
  //     "formType": "aside",
  //     "composite_form": true,
  //     "account_aware": {
  //       "auto_filters": false,
  //       "auto_columns": false,
  //       "post": false
  //     }
  //   };
  //   json.form["blocks"] = json.form["blocks"].concat(this.getConfigurationCommaJson());
  //   return json;
  // }

  getConfigurationNumberJson() {
    let json = [
      {
      "heading": "field.label.right_align_number",
      "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
      "order": 1,
      "type": "Boolean",
      "component": "checkbox",
      "name": "right_align_number"
    },
    {
      "heading": "field.label.center_align_number",
      "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
      "order": 2,
      "type": "Boolean",
      "component": "checkbox",
      "name": "center_align_number"
    },
    {
      "heading": "field.label.right_align_alphabetic",
      "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
      "order": 3,
      "type": "Boolean",
      "component": "checkbox",
      "name": "right_align_alphabetic"
    },
    {
      "heading": "field.label.center_align_alphabetic",
      "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
      "order": 4,
      "type": "Boolean",
      "component": "checkbox",
      "name": "center_align_alphabetic"
    }
  ]
  return json;  
  }

  getInitalFormJson(config) {
    var json = this.getBasicJson();
    json.resource = "configure_uiengine";
    if (config["context"] == 'grid') {
      if (config["limitField"] != undefined && config["limitField"]) {
        json.form["blocks"] = [{
          "name": "searchs",
          "order": 1,
          "layout_type": "one-column",
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_searchs",
              "type": "Array",
              "component": "composite-array",
              "name": "searchs",
              "item_key": "user_group_name"
            }
          ],
          "title": "ccs"
        }];
      }
      else {
        json.form["blocks"] = [
          {
            "name": "orders",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "default_open": true,
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_orders",
                "type": "Array",
                "component": "composite-array",
                "name": "orders",
                "item_key": "user_group_name"
              }
            ],
            "title": "cco"
          },
          {
            "name": "fields",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "default_open": true,
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_fields",
                "type": "Array",
                "component": "composite-array",
                "name": "fields",
                "item_key": "user_group_name"
              }
            ],
            "title": "ccl"
          },
          {
            "name": "actions",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_actions",
                "type": "Array",
                "component": "composite-array",
                "name": "actions",
                "item_key": "user_group_name"
              }
            ],
            "title": "cca"
          },
          {
            "name": "filters",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_filters",
                "type": "Array",
                "component": "composite-array",
                "name": "filters",
                "item_key": "user_group_name"
              }
            ],
            "title": "ccf"
          },
          {
            "name": "def_filters",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_def_filters",
                "type": "Array",
                "component": "composite-array",
                "name": "def_filters",
                "item_key": "user_group_name"
              }
            ],
            "title": "cdf"
          },          
          {
            "name": "def_complex_value",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_def_complex_value",
                "type": "Array",
                "component": "composite-array",
                "name": "def_complex_value",
                "item_key": "user_group_name"
              }
            ],
            "title": "adfps"
          },
          {
            "name": "def_add_prefix",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_def_add_prefix",
                "type": "Array",
                "component": "composite-array",
                "name": "def_add_prefix",
                "item_key": "user_group_name"
              }
            ],
            "title": "addpfs"
          },
          {
            "name": "searchs",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_searchs",
                "type": "Array",
                "component": "composite-array",
                "name": "searchs",
                "item_key": "user_group_name"
              }
            ],
            "title": "ccs"
          },
          {
            "name": "dwn_all_interval",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_dwn_all_interval",
                "type": "Array",
                "component": "composite-array",
                "name": "dwn_all_interval",
                "item_key": "user_group_name"
              }
            ],
            "title": "cdwninter"
          },
          {
            "name": "cap_orders",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_cap_orders",
                "type": "Array",
                "component": "composite-array",
                "name": "cap_orders",
                "item_key": "user_group_name"
              }
            ],
            "title": "ccao"
          },
          {
            "name": "add_btn",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_add_btn",
                "type": "Array",
                "component": "composite-array",
                "name": "add_btn",
                "item_key": "user_group_name"
              }
            ],
            "title": "ccsa"
          },
          {
            "name": "confirm_actions",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_confirm_actions",
                "type": "Array",
                "component": "composite-array",
                "name": "confirm_actions",
                "item_key": "user_group_name"
              }
            ],
            "title": "CnfRem"
          },
          {
            "name": "sort_allowed",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_sort_allowed",
                "type": "Array",
                "component": "composite-array",
                "name": "sort_allowed",
                "item_key": "user_group_name"
              }
            ],
            "title": "srt_alw"
          },
          {
            "name": "summary_def",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "default_open": true,
            "fields": [
              {
                "order": 1,
                "label": "summary",
                "resource": "configure_uiengine_summary",
                "type": "Array",
                "component": "composite-array",
                "name": "summary_def",
                "item_key": "user_group_name"
              }
            ],
            "title": "conf_summary"
          },
          {
            "name": "summary_sequence",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "default_open": true,
            "fields": [
              {
                "order": 1,
                "label": "summary",
                "resource": "configure_uiengine_summary_sequence",
                "type": "Array",
                "component": "composite-array",
                "name": "summary_sequence",
                "item_key": "user_group_name"
              }
            ],
            "title": "conf_summary_sequence"
          },
          {
            "name": "config_def",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "config",
                "resource": "configure_uiengine_config",
                "type": "Array",
                "component": "composite-array",
                "name": "config_def",
                "item_key": "user_group_name"
              }
            ],
            "title": "config_summary"
          },
          {
            "name": "fields_currency_config",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "config",
                "resource": "configure_uiengine_fields_currency_config",
                "type": "Array",
                "component": "composite-array",
                "name": "fields_currency_config",
                "item_key": "user_group_name"
              }
            ],
            "title": "fields_currency_config"
          },
          {
            "name": "summary_currency_config",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "fields": [
              {
                "order": 1,
                "label": "config",
                "resource": "configure_uiengine_summary_currency_config",
                "type": "Array",
                "component": "composite-array",
                "name": "summary_currency_config",
                "item_key": "user_group_name"
              }
            ],
            "title": "summary_currency_config"
          },
          {
            "name": "comma_seprated_fields",
            "order": 1,
            "group_type": "accordian",
            "layout_type": "one-column",
            "default_open": true,
            "fields": [
              {
                "order": 1,
                "label": "pua",
                "resource": "configure_uiengine_comma_seprated_fields",
                "type": "Array",
                "component": "composite-array",
                "name": "comma_seprated_fields",
                "item_key": "user_group_name"
              }
            ],
            "title": "csclmns"
          }
        ];
      }

    } else if (config["context"] == 'menu') {
      json.form["blocks"] = [
        {
          "name": "menus",
          "order": 0,
          "group_type": "accordian",
          "layout_type": "one-column",
          "default_open": true,
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_menus",
              "type": "Array",
              "component": "composite-array",
              "name": "menus",
              "item_key": "user_group_name"
            }
          ],
          "title": "cmenu"
        },
        // {
        //   "name": "menu_orders",
        //   "order": 1,
        //   "group_type": "accordian",
        //   "layout_type": "one-column",
        //   "default_open": true,
        //   "fields": [
        //     {
        //       "order": 1,
        //       "label": "pua",
        //       "resource": "configure_uiengine_menu_orders",
        //       "type": "Array",
        //       "component": "composite-array",
        //       "name": "menu_orders",
        //       "item_key": "user_group_name"
        //     }
        //   ],
        //   "title": "cmenuo"
        // }

      ];
    } else if (config["context"] == 'header') {
      json.form["blocks"] = [
        {
          "name": "headers",
          "order": 0,
          "group_type": "accordian",
          "layout_type": "one-column",
          "default_open": true,
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_headers",
              "type": "Array",
              "component": "composite-array",
              "name": "headers",
              "item_key": "user_group_name"
            }
          ],
          "title": "cheadc"
        },
        {
          "name": "careTypes",
          "order": 1,
          "group_type": "accordian",
          "layout_type": "one-column",
          "default_open": true,
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_careTypes",
              "type": "Array",
              "component": "composite-array",
              "name": "careTypes",
              "item_key": "user_group_name"
            }
          ],
          "title": "care_type"
        }

      ];
    } else if (config["context"] == 'edit_grid') {
      json.form["blocks"] = [
        {
          "name": "eg_caps",
          "order": 0,
          "group_type": "accordian",
          "layout_type": "one-column",
          "default_open": true,
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_eg_caps",
              "type": "Array",
              "component": "composite-array",
              "name": "eg_caps",
              "item_key": "user_group_name"
            }
          ],
          "title": "confeg"
        }
      ];
    } else if (config["context"] == 'banner') {
      json.form["blocks"] = [
        {
          "name": "banner_actions",
          "order": 0,
          "group_type": "accordian",
          "layout_type": "one-column",
          "default_open": true,
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_banner_actions",
              "type": "Array",
              "component": "composite-array",
              "name": "banner_actions",
              "item_key": "user_group_name"
            }
          ],
          "title": "confbanact"
        },
        {
          "name": "comma_seprated_fields",
          "order": 1,
          "group_type": "accordian",
          "layout_type": "one-column",
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_comma_seprated_fields",
              "type": "Array",
              "component": "composite-array",
              "name": "comma_seprated_fields",
              "item_key": "user_group_name"
            }
          ],
          "title": "csclmns"
        }
      ];
    } else {
      json.form["blocks"] = [
        {
          "name": "tab_orders",
          "order": 1,
          "group_type": "accordian",
          "layout_type": "one-column",
          "default_open": true,
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_tab_orders",
              "type": "Array",
              "component": "composite-array",
              "name": "tab_orders",
              "item_key": "user_group_name"
            }
          ],
          "title": "cto"
        },
        {
          "name": "tabs",
          "order": 1,
          "group_type": "accordian",
          "layout_type": "one-column",
          "default_open": true,
          "fields": [
            {
              "order": 1,
              "label": "pua",
              "resource": "configure_uiengine_tabs",
              "type": "Array",
              "component": "composite-array",
              "name": "tabs",
              "item_key": "user_group_name"
            }
          ],
          "title": "ct"
        }
      ];
    }

    return json;
  }

  getBasicJson() {
    return {
      "resource": "",
      "schema_name": "ui_engine",
      "form": {
      },
      "list": {
      }
    };
  }

  async getAllColumns(resourceDef) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      var allFields;
      if(resourceDef.list && resourceDef.list.dynamic_header && this.storge.getSessionStorageDataSync("dynamic_header_config")){
        allFields = await this.parseFields(this.storge.getSessionStorageDataSync("dynamic_header_config"));
      }else{
        allFields = await this.parseFields(resourceDef.list.fields)
      }
      return allFields;
    } catch (e) {
      return [];
    }
  }
  async getDownloadAllInterval(resourceDef) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      var allActions: any = [];
        allActions = [{ heading: 'day', name: 'day', order: 1 }, { heading: 'week', name: 'week', order: 1 }, { heading: 'month', name: 'month', order: 1 }, { heading: 'quarter', name: 'quarter', order: 1 }];
      
      allActions = await this.parseFields(allActions);
      return allActions;
    } catch (e) {
      return [];
    }
  }

  async getAllActions(resourceDef, removeDefault = false) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      var allActions: any = [];
      var actionsMap = [];
      if (!removeDefault) {
        allActions = [{ heading: 'field.label.add', name: 'add', order: 1 }, { heading: 'field.label.download', name: 'download', order: 1 }, { heading: 'field.label.print', name: 'print', order: 1 }, { heading: 'cg', name: 'configure_grid', order: 1 }];
        actionsMap = ['add', 'download', 'print','configure_grid'];
      }

      if (resourceDef.capability != null && Array.isArray(resourceDef.capability) && resourceDef.capability.length > 0) {

        for (let index = 0; index < resourceDef.capability.length; index++) {
          var cap = resourceDef.capability[index];
          var action = cap.action_name || cap.action;
          if (cap.label != undefined && (cap.action != undefined || cap.action_name != undefined) && (cap.action || cap.action_name) && cap.label && action != "custom" && actionsMap.indexOf(action) == -1) {

            allActions.push({ heading: cap.label, name: action, order: index + 1 });
            actionsMap.push(action);//for having unique action inside dropdown
          }
        }

      }

      if(resourceDef.config != undefined && resourceDef.config.master_upload != undefined){
        allActions.push({ heading:'menu.master_upload', name: 'master_upload', order: actionsMap.length });
        actionsMap.push('master_upload');//for having unique action inside dropdown
      }
      allActions = await this.parseFields(allActions);
      return allActions;
    } catch (e) {
      return [];
    }
  }

  async getAllConfirmActions(resourceDef) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      var allActions: any = [];
      var actionsMap = [];


      if (resourceDef.capability != null && Array.isArray(resourceDef.capability) && resourceDef.capability.length > 0) {

        for (let index = 0; index < resourceDef.capability.length; index++) {
          var cap = resourceDef.capability[index];
          var action = cap.action_name || cap.action;
          if (cap.label != undefined && (cap.action != undefined && (cap.action == 'confirm') && actionsMap.indexOf(action) == -1)) {

            allActions.push({ heading: cap.label, name: action, order: index + 1 });
            actionsMap.push(action);//for having unique action inside dropdown
          }
        }

      }
      allActions = await this.parseFields(allActions);
      return allActions;
    } catch (e) {
      return [];
    }
  }

  async getBannerActions(resourceDef) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      var allActions: any = [];

      allActions.push({ heading: "Dummy Action", name: "dummy" });
      if (resourceDef.bannerJson.emp_action != undefined) {
        allActions.push({ heading: "edit_demo", name: "edit_demo" });
        allActions.push({ heading: "edit_emp", name: "edit_emp" });
      }

      if (resourceDef.jsonFields != undefined && Array.isArray(resourceDef.jsonFields) && resourceDef.jsonFields.length > 0) {
        for (let index = 0; index < resourceDef.jsonFields.length; index++) {
          var json = resourceDef.jsonFields[index];
          if (json.name == 'link' && json.config != undefined && json.config.footerLinks) {
            for (let i = 0; i < json.config.footerLinks.length; i++) {
              let config = json.config.footerLinks[i];
              if (config.label != undefined && config.action != undefined) {
                allActions.push({ heading: config.label, name: config.action });
              }
            }
          }
        }
      }
      allActions = await this.parseFields(allActions);
      return allActions;
    } catch (e) {
      return [];
    }
  }

  async getBannerFields(jsonFields) {
    if (!Array.isArray(jsonFields)) {
      return [];
    }
    try {
      return await this.parseFields(jsonFields.filter(json => json.name != 'link'));
    } catch (e) {
      console.error("Error in getting banner fields", e);
      return [];
    }
  }

  async getAllowedSorting(resourceDef) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      var allActions: any = [];

      if (resourceDef.config != undefined && resourceDef.config.sorting_allowed != undefined && Array.isArray(resourceDef.config.sorting_allowed) && resourceDef.config.sorting_allowed.length > 0) {
        for (let index = 0; index < resourceDef.config.sorting_allowed.length; index++) {
          var item = resourceDef.config.sorting_allowed[index];
          allActions.push({ heading: item, name: item });
        }
      }
      allActions = await this.parseFields(allActions);
      return allActions;
    } catch (e) {
      return [];
    }
  }


  async getEditableGridCaps(resourceDef, removeDefault = false) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      var allActions: any = [];
      if (resourceDef.list != undefined && resourceDef.list.actions != undefined && resourceDef.list.actions.length > 0 && resourceDef.list.actions[0].conditions != undefined && Array.isArray(resourceDef.list.actions[0].conditions) && resourceDef.list.actions[0].conditions.length > 0) {
        var allowedActions = ["delete", "add", "copy", "location"]
        for (let index = 0; index < resourceDef.list.actions[0].conditions.length; index++) {
          var actionObj = resourceDef.list.actions[0].conditions[index];
          for (let i = 0; i < allowedActions.length; i++) {
            let act = allowedActions[i];
            if (actionObj[act] != undefined && actionObj[act]) {
              allActions.push({ heading: act, name: act });
            }
          }
        }

      }
      allActions = await this.parseFields(allActions);
      return allActions;
    } catch (e) {
      return [];
    }
  }

  async getAllHeaders(resourceDef) {
    var allHeaderList = this.preferenceService.getHeaderList();
    var allHeaders = await this.parseFields(allHeaderList);
    return allHeaders;
  }

  async getAllMenus(resourceDef, removeDefault = false) {
    if (resourceDef == undefined || resourceDef["navItems"] == undefined) {
      return [];
    }
    try {
      resourceDef.navItems = JSON.parse(JSON.stringify(resourceDef.navItems));
      var allActions = [];
      if (resourceDef.navItems != null && Array.isArray(resourceDef.navItems) && resourceDef.navItems.length > 0) {
        allActions = this.loopMenu(resourceDef.navItems, allActions, 0);
      }
      var allFields: any = await this.parseFields(allActions);
      for (let index = 0; index < allFields.length; index++) {
        var menu = allFields[index];
        menu.visible = true;
        if (menu.level > 0) {
          if (menu.level == 1) {
            menu.text = ">>Submenu " + menu.level + ": " + menu.text;
          } else if (menu.level == 2) {
            menu.text = ">>>>Submenu " + menu.level + ": " + menu.text;
          } else {
            menu.text = "Submenu " + menu.level + ": " + menu.text;
          }
        }
      }
      return allFields;
    } catch (e) {
      return [];
    }
  }

  loopMenu(navItems, allActions, level) {
    return this.preferenceService.loopMenu(navItems, allActions, level);
  }

  async getAllFilters(resourceDef) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      if (resourceDef.list != undefined && resourceDef.list.filter != undefined) {
        var fields = await this.getAllFormFields(resourceDef.list.filter);
        return fields;
      }
      return [];
    } catch (e) {
      return [];
    }
  }

  async getAllSearchs(resourceDef) {
    return await this.getComplexSearchs("list", resourceDef);
  }
  async getAllAddSearchs(resourceDef) {
    return await this.getComplexSearchs("addButton", resourceDef);
  }
  async getAllCareType() {
    var careType = this.appService.getUniversalConfig("care_type");
    if (careType != undefined && Array.isArray(careType) && careType.length) {
      var types = [];
      for (let index = 0; index < careType.length; index++) {
        var item = careType[index];
        types.push({ name: item["id"], heading: item["name"] });
      }
      return await this.parseFields(types);
    }
    return [];
  }

  async getComplexSearchs(key, resourceDef) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      if (resourceDef[key] != undefined && resourceDef[key].complex_search != undefined && Array.isArray(resourceDef[key].complex_search) && resourceDef[key].complex_search.length > 0) {
        var allFields: any = [];
        var actionsMap = [];
        for (let index = 0; index < resourceDef[key].complex_search.length; index++) {
          let search = resourceDef[key].complex_search[index];
          if (search.key != undefined && search.key != "" && search.label != undefined && search.label != "" && actionsMap.indexOf(search.key) == -1) {
            allFields.push({ heading: search.label, name: search.key });
            actionsMap.push(search.key);//for having unique action inside dropdown
          }
        }
        return await this.parseFields(allFields)
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  }

  async getAllFormFields(form) {
    if (form.blocks != undefined && Array.isArray(form.blocks) && form.blocks.length > 0) {
      var currentFormFields: any = {};
      return new Promise((resolve, reject) => {
        this.baseService.getReferredField(form, (response) => {
          currentFormFields.blocks = response;
          var fieldGroups = this.formService.buildFormGroup({}, currentFormFields);
          if (Object.keys(this.formService.questionMapping).length > 0) {
            var allFields: any = [];
            var actionsMap = [];
            for (let f in this.formService.questionMapping) {
              if (f && !(this.formService.questionMapping[f].label instanceof HiddenQuestion) && this.formService.questionMapping[f].label != undefined && this.formService.questionMapping[f].label != "" && actionsMap.indexOf(f) == -1) {
                let obj = { heading: this.formService.questionMapping[f].label, name: f };
                obj = { ...this.formService.questionMapping[f], ...obj };
                allFields.push(obj);
                actionsMap.push(f);//for having unique action inside dropdown
              }
            }
            this.parseFields(allFields).then((res) => {
              resolve(res);
            });
          } else {
            resolve([]);
          }
        });
      });
    }
  }
  async getAllTabs(resourceDef) {
    if (resourceDef == undefined) {
      return [];
    }
    try {
      var layoutData = resourceDef["layout"];
      if (Object.keys(layoutData) && Object.keys(layoutData).length > 0) {
        var allTabs: any = [];
        var actionsMap = [];
        for (let index = 0; index < Object.keys(layoutData).length; index++) {
          var tab = layoutData[Object.keys(layoutData)[index]];
          if (tab.id != undefined && tab.layoutName != undefined && actionsMap.indexOf(tab.id) == -1) {
            allTabs.push({ heading: tab.layoutName, name: tab.id, order: index + 1 });
            actionsMap.push(tab.id);//for having unique action inside dropdown
          }
        }
        allTabs = await this.parseFields(allTabs);
        return allTabs;
      }
      return [];
    } catch (e) {
      return [];
    }
  }



  async parseFields(list) {
    if (Array.isArray(list)) {
      var allPromiseObj = [];
      var allFieldList = [];
      var fieldMap = {};
      var fieldIndexMap = {};
      var lngIndex = 0;;
      for (let index = 0; index < list.length; index++) {
        let col = list[index];
        if (col.name != undefined && col.name && col.heading != undefined && col.heading) {
          if (col.setting_heading) {
            allPromiseObj.push(this.baseService.asyncLanguageProcess(col.setting_heading, true));
          } else
            allPromiseObj.push(this.baseService.asyncLanguageProcess(col.heading, true));
          if (col.mapKey != undefined) {
            fieldIndexMap[lngIndex] = col.mapKey+"_"+col.name;
            fieldMap[col.mapKey+"_"+col.name] = index;
          } else {
            fieldIndexMap[lngIndex] = col.heading+"_"+col.name;
            fieldMap[col.heading+"_"+col.name] = index;
          }

          lngIndex++;
        }
      }
      return new Promise((resolve, reject) => {
        Promise.all(allPromiseObj).then((promiseResponse) => {
          for (let index = 0; index < promiseResponse.length; index++) {
            let colHeading = promiseResponse[index];
            this.config.languageMap[fieldIndexMap[index]+"_"+list[fieldMap[fieldIndexMap[index]]].name] = colHeading;
            let obj = { id: list[fieldMap[fieldIndexMap[index]]].name, text: colHeading };
            if (list[fieldMap[fieldIndexMap[index]]]["order"] != undefined) {
              obj = { ...list[fieldMap[fieldIndexMap[index]]], ...obj };
            }
            allFieldList.push(obj);
          }
          resolve(allFieldList);
        });
      });
    } else {
      Promise.resolve([]);
    }
  }

}
